// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-text[data-v-0f3d1c30]{font-size:1.05em;font-weight:500;margin-top:25px}.title-text[data-v-0f3d1c30]:first-of-type{margin-top:10px}.tag-padding[data-v-0f3d1c30]{height:200px;width:100%;display:block}.progressbar[data-v-0f3d1c30]{margin-top:10px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
